// features/userSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import secureLocalStorage from "react-secure-storage";
import { getAxiosWithOutToken, getAxiosWithToken } from "../../axios/axiosObj";
import { GET_MOOD_NOTIFICATION } from "../../config/ApisCollection";

const initialState = {
  loading: false,
  accessToken: secureLocalStorage.getItem("accessToken")
    ? secureLocalStorage.getItem("accessToken")
    : false,
  refreshToken: secureLocalStorage.getItem("refreshToken")
    ? secureLocalStorage.getItem("refreshToken")
    : false,
  isLoggedIn: secureLocalStorage.getItem("isLoggedIn")
    ? secureLocalStorage.getItem("isLoggedIn")
    : false,
  pageError: false,
  errorMsg: "",
  profileDetails: secureLocalStorage.getItem("profileDetails")
    ? secureLocalStorage.getItem("profileDetails")
    : false,
  isDrawerActive: secureLocalStorage.getItem("isDrawerActive")
    ? secureLocalStorage.getItem("isDrawerActive")
    : false,
  drawerActiveMenu: secureLocalStorage.getItem("drawerActiveMenu")
    ? secureLocalStorage.getItem("drawerActiveMenu")
    : null,
};

export const getProfileDetails = createAsyncThunk(
  "auth/getProfileDetails",
  async (data) => {
    try {
      const response = await getAxiosWithToken({
        method: "GET",
        url: "pro/log/profile",
      });
      const responseData = {
        data: response.data,
        status: response.status,
      };
      return responseData;
    } catch (error) {
      return { error: error.response.data }; // Return only the error data
    }
  }
);

export const getNotificationNum = createAsyncThunk(
  GET_MOOD_NOTIFICATION,
  async (data) => {
    try {
      const response = await getAxiosWithToken({
        method: "GET",
        url: "/pro/log/profile/notification",
      });
      const responseData = {
        data: response.data,
        status: response.status,
      };
      return responseData;
    } catch (error) {
      return { error: error.response.data }; // Return only the error data
    }
  }
);

export const loginWithPassword = createAsyncThunk(
  "auth/loginWithPassword",
  async (data) => {
    try {
      const data = {
        email: "demo8@example.com", //{"demo1@example.com","demo4@example.com","demo7@example.com","demo8@example.com"}
        password: "1234567", //{"1234567","12345678"}
      };
      const response = await getAxiosWithOutToken({
        method: "POST",
        url: "pre/auth/login",
        data: data,
      });
      const responseData = {
        data: response.data,
        status: response.status,
      };
      return responseData;
    } catch (error) {
      return { error: error.response.data }; // Return only the error data
    }
  }
);

export const sendOtp = createAsyncThunk("auth/sendOtp", async (data) => {
  try {
    const response = await getAxiosWithOutToken({
      method: "POST",
      url: "pre/auth/send-otp",
      data: data,
    });
    const responseData = {
      data: response.data,
      status: response.status,
    };
    return responseData;
  } catch (error) {
    return { error: error.response.data }; // Return only the error data
  }
});

export const verifyOtp = createAsyncThunk("auth/verifyOtp", async (data) => {
  try {
    const response = await getAxiosWithOutToken({
      method: "POST",
      url: "pre/auth/login-with-otp",
      data: data,
    });
    const responseData = {
      data: response.data,
      status: response.status,
    };
    return responseData;
  } catch (error) {
    return { error: error.response.data }; // Return only the error data
  }
});

export const refreshToken2 = createAsyncThunk(
  "auth/refreshToken2",
  async (data) => {
    try {
      const response = await getAxiosWithOutToken({
        method: "POST",
        url: "pro/auth/refresh-token",
        data: {
          refreshToken: secureLocalStorage.getItem("refreshToken"),
        },
      });
      const responseData = {
        data: response.data,
        status: response.status,
      };
      return responseData;
    } catch (error) {
      if (error.response.data.error.message === "Unauthorized") {
        secureLocalStorage.clear();
      }
      return { error: error.response.data }; // Return only the error data
    }
  }
);

export const userLogOut = createAsyncThunk("user/userLogOut", async () => {
  try {
    // Clear local storage and reload the page on logout
    await getAxiosWithOutToken({
      method: "DELETE",
      url: "pro/auth/logout",
      data: {
        refreshToken: secureLocalStorage.getItem("refreshToken"),
      },
    });
    localStorage.clear();
    secureLocalStorage.clear();
    window.location.reload();
  } catch (error) {
    // Handle error or dispatch error-related actions here
    console.log(error);
  }
});

export const webUtilitiesSlice = createSlice({
  name: "webUtilities",
  initialState,
  reducers: {
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload;
    },
    setErrorMsg: (state, action) => {
      state.errorMsg = action.payload;
    },
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setPageError: (state, action) => {
      state.pageError = action.payload;
    },
    setIsDrawerActive: (state, action) => {
      secureLocalStorage.setItem("isDrawerActive", action.payload);
      state.isDrawerActive = action.payload;
    },
    setDrawerActiveMenu: (state, action) => {
      secureLocalStorage.setItem("drawerActiveMenu", action.payload);
      state.drawerActiveMenu = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendOtp.fulfilled, (state, action) => {
        if (action.payload.error) {
          state.errorMsg = action.payload.error.error.message;
        } else {
          window.location.href = "loginverfiy";
        }
      })
      .addCase(sendOtp.rejected, (state) => {
        console.log("error:", state);
      })
      .addCase(verifyOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginWithPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        if (action.payload.error) {
          state.errorMsg = action.payload.error.error.message;
        } else {
          state.isLoggedIn = true;
          secureLocalStorage.setItem("isLoggedIn", "true");
          secureLocalStorage.setItem(
            "accessToken",
            action.payload.data.accessToken
          );
          secureLocalStorage.setItem(
            "refreshToken",
            action.payload.data.refreshToken
          );
          state.accessToken = action.payload.data.accessToken;
          state.refreshToken = action.payload.data.refreshToken;
          window.location.href = "/";
        }
      })
      .addCase(loginWithPassword.fulfilled, (state, action) => {
        if (action.payload.error) {
          state.errorMsg = action.payload.error.error.message;
        } else {
          state.isLoggedIn = true;
          secureLocalStorage.setItem("isLoggedIn", "true");
          secureLocalStorage.setItem(
            "accessToken",
            action.payload.data.accessToken
          );
          secureLocalStorage.setItem(
            "refreshToken",
            action.payload.data.refreshToken
          );
          state.accessToken = action.payload.data.accessToken;
          state.refreshToken = action.payload.data.refreshToken;
          window.location.href = "/";
        }
      })
      .addCase(verifyOtp.rejected, (state) => {
        console.log("error:", state);
      })
      .addCase(refreshToken2.pending, (state) => {
        state.loading = true;
      })
      .addCase(refreshToken2.fulfilled, (state, action) => {
        if (action.payload.error) {
          state.errorMsg = action.payload.error.error.message;
        } else {
          secureLocalStorage.setItem(
            "accessToken",
            action.payload.data.accessToken
          );
          secureLocalStorage.setItem(
            "refreshToken",
            action.payload.data.refreshToken
          );
          state.accessToken = action.payload.data.accessToken;
          state.refreshToken = action.payload.data.refreshToken;
          window.location.reload();
        }
      })
      .addCase(refreshToken2.rejected, (state) => {
        console.log("error:", state);
      })
      .addCase(getProfileDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProfileDetails.fulfilled, (state, action) => {
        if (action.payload.error) {
          state.errorMsg = action.payload.error.error.message;
        } else {
          secureLocalStorage.setItem(
            "profileDetails",
            action.payload.data.data
          );
          state.profileDetails = action.payload.data.data;
        }
      })
      .addCase(getProfileDetails.rejected, (state) => {
        console.log("error:", state);
      });
  },
});

export const {
  setLoading,
  setGenderRaw,
  setErrorMsg,
  setPageError,
  setIsLoggedIn,
  setIsDrawerActive,
  setDrawerActiveMenu,
} = webUtilitiesSlice.actions;
export const selectWebUtilities = (state) => state.webUtilities;
export default webUtilitiesSlice.reducer;
